/* Lovera ALT – interaktsioonid (test, ei ole avaldatud) */
(function(){
  'use strict';
  var d=document,w=window;
  function $$(s,r){return Array.prototype.slice.call((r||d).querySelectorAll(s));}
  function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
  function lsGet(k){try{return w.localStorage.getItem(k);}catch(e){return null;}}
  function lsSet(k,v){try{w.localStorage.setItem(k,v);}catch(e){}}

  /* reveal on scroll */
  function initReveal(root){
    var els=$$('[data-a-reveal],.a-hero,[data-a-rings]',root);
    if(!('IntersectionObserver' in w)){els.forEach(function(e){e.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('is-in');
        if(e.target.hasAttribute('data-a-rings'))fillRings(e.target);
        io.unobserve(e.target);}
    });},{threshold:.18,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){io.observe(e);});
  }

  /* rotating words in hero */
  function initRotator(root){
    $$('[data-a-rotator]',root).forEach(function(r){
      if(r._a)return;r._a=1;
      var items=$$('span',r),i=0;if(items.length<2)return;
      items[0].classList.add('is-on');
      setInterval(function(){
        var cur=items[i];cur.classList.remove('is-on');cur.classList.add('is-out');
        setTimeout(function(){cur.classList.remove('is-out');},600);
        i=(i+1)%items.length;items[i].classList.add('is-on');
      },2400);
    });
  }

  /* self-check quiz */
  function initQuiz(root){
    $$('[data-a-quiz]',root).forEach(function(q){
      if(q._a)return;q._a=1;
      var opts=$$('.a-opt',q),bar=q.querySelector('.a-meter i'),cnt=q.querySelector('[data-count]'),msg=q.querySelector('[data-msg]');
      var msgs=JSON.parse(q.getAttribute('data-msgs')||'[]');
      function upd(){
        var n=opts.filter(function(o){return o.getAttribute('aria-pressed')==='true';}).length;
        bar.style.width=(n/opts.length*100)+'%';cnt.textContent=n;
        var m=msgs[Math.min(n,msgs.length-1)]||'';msg.innerHTML=m;
      }
      opts.forEach(function(o){o.addEventListener('click',function(){
        o.setAttribute('aria-pressed',o.getAttribute('aria-pressed')==='true'?'false':'true');upd();
        if(navigator.vibrate)try{navigator.vibrate(8);}catch(e){}
      });});
      upd();
    });
  }

  /* tabs */
  function initTabs(root){
    $$('[data-a-tabs]',root).forEach(function(t){
      if(t._a)return;t._a=1;
      var tabs=$$('.a-tab',t),panels=$$('.a-panel',t);
      tabs.forEach(function(b,i){b.addEventListener('click',function(){
        tabs.forEach(function(x,j){x.setAttribute('aria-selected',i===j?'true':'false');});
        panels.forEach(function(p,j){p.classList.toggle('is-on',i===j);});
      });});
    });
  }

  /* scroll-driven follicle */
  var scrollers=[];
  function initHow(root){
    $$('[data-a-how]',root).forEach(function(h){
      if(h._a)return;h._a=1;
      scrollers.push(function(){
        var r=h.getBoundingClientRect(),vh=w.innerHeight;
        var p=clamp((vh*.85-r.top)/(r.height*.9),0,1);
        h.style.setProperty('--g',p.toFixed(3));
        var step=p<.34?0:(p<.67?1:2);
        $$('.a-step',h).forEach(function(s,i){s.classList.toggle('is-on',i===step);});
        var svg=h.querySelector('svg');
        if(svg){
          $$('[data-hair]',svg).forEach(function(el,i){
            var base=parseFloat(el.getAttribute('data-base')||'.15'),g=clamp(base+(1-base)*clamp(p*1.25-i*.05,0,1),0,1);
            el.style.transform='scaleY('+g.toFixed(3)+')';
          });
          $$('[data-pep]',svg).forEach(function(el,i){
            var t=clamp((p-.25)*2.2-i*.06,0,1);
            el.style.opacity=(t>0&&t<1?1:0).toString();
            el.style.transform='translate(0,'+(t*150).toFixed(1)+'px)';
          });
          $$('[data-bulb]',svg).forEach(function(el){el.style.opacity=(.35+p*.65).toFixed(2);});
        }
      });
    });
  }

  /* timeline rail */
  function initTimeline(root){
    $$('[data-a-tl]',root).forEach(function(t){
      if(t._a)return;t._a=1;
      var rail=t.querySelector('.a-tl__rail i'),items=$$('.a-tl__item',t);
      scrollers.push(function(){
        var r=t.getBoundingClientRect(),vh=w.innerHeight,desk=w.innerWidth>=900;
        var p=clamp((vh*.75-r.top)/(r.height+(desk?vh*.1:0)),0,1);
        if(desk){rail.style.width=(p*100)+'%';rail.style.height='100%';}else{rail.style.height=(p*100)+'%';rail.style.width='100%';}
        items.forEach(function(it,i){it.classList.toggle('is-on',p>=(i/(items.length))+.02);});
      });
    });
  }

  /* before / after */
  function initBA(root){
    $$('[data-a-ba]',root).forEach(function(b){
      if(b._a)return;b._a=1;
      var inp=b.querySelector('input');
      function set(v){b.style.setProperty('--p',v+'%');}
      inp.addEventListener('input',function(){set(inp.value);});
      set(inp.value);
      /* small hint animation when first visible */
      if('IntersectionObserver' in w){
        var io=new IntersectionObserver(function(en){if(en[0].isIntersecting){io.disconnect();
          var t0=null;function step(ts){if(!t0)t0=ts;var k=(ts-t0)/1400;if(k>1){set(50);inp.value=50;return;}
            var v=50+Math.sin(k*Math.PI*2)*18;set(v.toFixed(1));requestAnimationFrame(step);}
          requestAnimationFrame(step);}},{threshold:.5});
        io.observe(b);
      }
    });
  }

  /* rings */
  function fillRings(el){
    $$('.a-ring',el).forEach(function(r){
      var v=parseFloat(r.getAttribute('data-v')||'0'),fg=r.querySelector('.fg'),b=r.querySelector('b');
      fg.style.strokeDashoffset=(251.3*(1-v/100)).toFixed(1);
      var t0=null;function step(ts){if(!t0)t0=ts;var k=clamp((ts-t0)/1500,0,1),e=1-Math.pow(1-k,3);
        b.textContent=Math.round(v*e)+'%';if(k<1)requestAnimationFrame(step);}
      requestAnimationFrame(step);
    });
  }

  /* bundle picker (links to product page) */
  function initBundles(root){
    $$('[data-a-bundles]',root).forEach(function(g){
      if(g._a)return;g._a=1;
      var opts=$$('.a-bundle',g),btn=g.querySelector('[data-a-go]'),lbl=g.querySelector('[data-a-go-label]');
      function pick(o){opts.forEach(function(x){x.setAttribute('aria-checked',x===o?'true':'false');});
        if(lbl)lbl.textContent=o.getAttribute('data-label')||lbl.textContent;}
      opts.forEach(function(o){o.addEventListener('click',function(){pick(o);});});
    });
  }

  /* sticky bar: shows after hero, hides near footer */
  function initSticky(){
    var s=d.querySelector('.a-sticky');if(!s||s._a)return;s._a=1;
    var trigger=d.querySelector(s.getAttribute('data-after')||'.a-hero')||d.body;
    scrollers.push(function(){
      var r=trigger.getBoundingClientRect(),f=d.querySelector('footer'),fr=f?f.getBoundingClientRect().top:1e9;
      s.classList.toggle('is-on',r.bottom<0&&fr>w.innerHeight);
    });
  }

  /* email popup */
  function initPopup(){
    var p=d.querySelector('[data-a-pop]');if(!p||p._a)return;p._a=1;
    var key='a_pop_seen',delay=parseInt(p.getAttribute('data-delay')||'14',10)*1000;
    var success=p.hasAttribute('data-success');
    function open(){if(p.classList.contains('is-on'))return;p.classList.add('is-on');lsSet(key,'1');}
    function close(){p.classList.remove('is-on');}
    $$('[data-a-pop-close]',p).forEach(function(b){b.addEventListener('click',close);});
    p.addEventListener('click',function(e){if(e.target===p)close();});
    if(success){open();return;}
    if(lsGet(key)&&!/a_pop=1/.test(location.search))return;
    var t=setTimeout(open,/a_pop=1/.test(location.search)?800:delay);
    d.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<5){clearTimeout(t);open();}});
  }

  /* one scroll loop */
  var ticking=false;
  function onScroll(){if(ticking)return;ticking=true;requestAnimationFrame(function(){scrollers.forEach(function(f){f();});ticking=false;});}

  function init(root){
    d.body.classList.add('a-alt');
    initReveal(root);initRotator(root);initQuiz(root);initTabs(root);initHow(root);initTimeline(root);initBA(root);initBundles(root);
    initSticky();initPopup();onScroll();
  }
  w.addEventListener('scroll',onScroll,{passive:true});
  w.addEventListener('resize',onScroll);
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){init(d);});else init(d);
  d.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
